(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/pages/deposit/deposit.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/pages/deposit/deposit.js');
'use strict';

const {
  useRef
} = React;
const deposit = svs.accountservicesReact.deposit;
const Button = svs.ui.ReactButton;
const {
  Footer,
  Header,
  DesktopContentConstrain,
  PageTitle,
  FadeInSlideWrapper
} = svs.playerRegistration.components;
const {
  GridBase
} = svs.tb_ui_react.gridbase;
const StepIndicatorBalls = svs.components.tb_ui.stepIndicatorBalls.StepIndicatorBalls;
const helpers = svs.playerRegistration.helpers;
const {
  showDoDepositLaterDialog
} = svs.playerRegistration.dialogs;
const DEPOSIT_PAY_SUPPORTED_PRODUCTS = svs.accountservicesReact.deposit.constants.DEPOSIT_PAY_SUPPORTED_PRODUCTS;
const Deposit = () => {
  var _extraData$product, _extraData$product$to;
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);
  const extraData = ReactRedux.useSelector(state => state.playerregistrationreact);
  const returnUrl = helpers.getReturnUrl();
  const isInRegisterFlow = helpers.getIsInRegisterFlow(extraData === null || extraData === void 0 ? void 0 : extraData.setLimits);
  const depositComponentRef = useRef();
  const preDefinedLimitsSupporternEnabled = helpers.getPreDefinedLimitsSupporternEnabled();
  const onGoingGameDataNumericAmount = isNaN(Number(extraData === null || extraData === void 0 ? void 0 : extraData.amount)) ? 0 : Number(extraData === null || extraData === void 0 ? void 0 : extraData.amount);
  const productLower = extraData === null || extraData === void 0 || (_extraData$product = extraData.product) === null || _extraData$product === void 0 || (_extraData$product$to = _extraData$product.toLowerCase) === null || _extraData$product$to === void 0 ? void 0 : _extraData$product$to.call(_extraData$product);
  const instantPay = preDefinedLimitsSupporternEnabled && DEPOSIT_PAY_SUPPORTED_PRODUCTS.includes(productLower) ? {
    amount: onGoingGameDataNumericAmount,
    isPay: false,
    product: productLower,
    isDepositAndPay: true
  } : {};
  const isDepositAndPay = instantPay === null || instantPay === void 0 ? void 0 : instantPay.isDepositAndPay;
  const cleanUpTransaction = () => {
    var _depositComponentRef$;
    depositComponentRef === null || depositComponentRef === void 0 || (_depositComponentRef$ = depositComponentRef.current) === null || _depositComponentRef$ === void 0 || (_depositComponentRef$ = _depositComponentRef$.depositCreditcard) === null || _depositComponentRef$ === void 0 || (_depositComponentRef$ = _depositComponentRef$.swedbankPayCheckout) === null || _depositComponentRef$ === void 0 || _depositComponentRef$.cleanUpSwedbankPayTransaction();
  };
  const handleDoDepositLater = () => {
    if (isButtonDisabled) {
      return;
    }
    setIsButtonDisabled(true);
    if (extraData !== null && extraData !== void 0 && extraData.product) {
      var _extraData$productInf;
      showDoDepositLaterDialog(extraData === null || extraData === void 0 || (_extraData$productInf = extraData.productInfo) === null || _extraData$productInf === void 0 ? void 0 : _extraData$productInf.productDisplayName, () => {
        cleanUpTransaction();
        svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl, svs.core.urlMapping.get('startPage')));
      }, () => {
        setIsButtonDisabled(false);
      });
    } else {
      svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl, svs.core.urlMapping.get('startPage')));
    }
  };
  return React.createElement(React.Fragment, null, React.createElement(Header, null), React.createElement(DesktopContentConstrain, null, React.createElement(GridBase, {
    className: "margin-xl-top-2 margin-lg-top-2 padding-xl-top-4 padding-lg-top-4"
  }, React.createElement("div", {
    className: "margin-bottom-1"
  }, React.createElement(StepIndicatorBalls, {
    isLabelsHidden: true,
    isShowDottedLines: true,
    step: 3
  })), React.createElement(FadeInSlideWrapper, null, React.createElement(PageTitle, null, isDepositAndPay ? 'Sätt in och betala spelet' : 'Sätt in på spelkontot'), React.createElement("p", {
    className: "h4 margin-bottom-1"
  }, React.createElement("span", {
    className: "registration-bread-text"
  }, isDepositAndPay ? 'Ditt spel kommer betalas samtidigt som du sätter in pengar. Om du sätter in mer än spelets kostnad sätts pengarna in på ditt spelkonto.' : 'Innan du kan betala för spel behöver du sätta in pengar på ditt spelkonto.')), React.createElement("div", {
    className: "registration-deposit padding-xs-top-2"
  }, React.createElement(deposit.Deposit, {
    hasNoProfileLinkSwish: !isInRegisterFlow,
    instantPay: instantPay,
    isHideDepositLimits: true,
    isPlayerRegistration: isInRegisterFlow,
    swedbankPayProps: {
      hasBackButton: false,
      backButtonText: 'Avbryt'
    }
  })), React.createElement("div", {
    className: "registration-deposit-do-it-later-button margin-xs-v-2"
  }, React.createElement("div", {
    className: "margin-xs-top-2"
  }, React.createElement(Button, {
    block: true,
    className: "margin-xs-top-2",
    disabled: isButtonDisabled,
    onClick: handleDoDepositLater,
    transparent: true
  }, "S\xE4tt in senare"))), React.createElement(Footer, null)))));
};
svs.playerRegistration.pages.deposit.Deposit = Deposit;

 })(window);